import { thunk } from 'redux-thunk'
import { AnyAction, applyMiddleware, createStore, Store } from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension'

import { history } from '~/app/utils/history'
import { rootReducer } from '~/app/store/rootReducer'
import { locationToState, stateToLocation } from '~/app/store/locationState/middleware'
import { analyticsMiddlewareFactory } from '~/app/store/analytics'

const defaultInitialState = {} as State.GlobalState

/**
 * creates a store from a given state and enhancerions
 */
export const configureStore = (initialState: State.GlobalState = defaultInitialState, analytics?: Gallery.Analytics.IAnalytics): Store<State.GlobalState> => {
  const middlewares = [stateToLocation(history), thunk]
  if (analytics) {
    middlewares.push(analyticsMiddlewareFactory(analytics))
  }
  const middlewareEnhancer = applyMiddleware(...middlewares)
  const composedEnhancers = composeWithDevTools({ trace: true })(middlewareEnhancer)
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  const store = createStore<State.GlobalState, AnyAction, {}>(rootReducer, initialState, composedEnhancers)

  locationToState(store.dispatch)

  analytics?.hydrate(store.getState())

  return store
}
